import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import qs from 'qs';
import classNames from 'classnames';
import app, { EVENT_DEVICE_TYPE_CHANGED } from 'general/js/app';
import gtm from 'general/js/gtm';
import eventBus from 'general/js/event-bus';
import { makeCancelable } from 'general/js/helpers';
import { NewsFeedService } from 'general/js/services';
import { NewsFeedListing, getPattern } from 'components/news-feed';
import { BlockSpinner } from 'components/block-spinner';

class NewsFeedLiveLayout extends React.Component {
    constructor(...args) {
        super(...args);
        this.data = null;
        this.state = {
            items: [],
            pagination: {
                currentPage: 0,
            },
            pattern: getPattern(app.deviceTypeByViewport),
            isFetching: false,
            showPartialPattern: true,
            tags: [],
        };
    }

    componentDidMount() {
        NewsFeedService.onChange(this.onNewsFeedServiceChange);
        eventBus.addListener(EVENT_DEVICE_TYPE_CHANGED, this.onChangeDeviceType);
        this.getData();
    }

    componentWillUnmount() {
        eventBus.removeListener(EVENT_DEVICE_TYPE_CHANGED, this.onChangeDeviceType);
        this.cancelGetData();
    }

    onChangeDeviceType = (oldDeviceType, newDeviceType) => {
        this.setState({ pattern: getPattern(newDeviceType) });
    }

    onNewsFeedServiceChange = (tags) => {
        this.setState({
            tags,
            pagination: {
                currentPage: 0
            }
        }, () => this.getData());
    }

    getData(isLoadMore) {
        const { endpointUrl, tags, newsfeedParentItemGuid } = this.props.options;
        const currentPage = this.state.pagination.currentPage;
        const paginationQs = qs.stringify({ currentPage: currentPage + 1 });
        const tagsQs = qs.stringify({ tags: [...tags, ...this.state.tags] });
        const newsfeedParentItemGuidQs = qs.stringify({ newsfeedParentItemGuid: newsfeedParentItemGuid });
        const url = `${endpointUrl}?${newsfeedParentItemGuidQs}&${paginationQs}&${tagsQs}`;

        this.cancelGetData();
        this.cancelableGetData = makeCancelable(axios.get(url));
        this.cancelableGetData
            .promise
            .then((response) => {
                let { items } = response.data;

                if (!Array.isArray(items)) {
                    this.setState({ isFetching: false });
                    return;
                }

                let showPartialPattern = items.length > 4;

                if (isLoadMore) {
                    items = [...this.state.items, ...items];
                    showPartialPattern = false;
                }

                this.setState({
                    items,
                    pagination: response.data.pagination,
                    showPartialPattern,
                    isFetching: false
                });
            })
            .catch(() => {
                this.setState({ isFetching: false });
            });

        this.setState({ isFetching: true });
    }

    cancelGetData() {
        if (this.cancelableGetData) {
            this.cancelableGetData.cancel();
        }
    }

    onLoadMore = () => {
        if (this.state.showPartialPattern) {
            this.setState({ showPartialPattern: false });
            return;
        }

        this.getData(true);
    }

    getItems() {
        const { showPartialPattern, items } = this.state;

        if (showPartialPattern) {
            return items.slice(0, 4);
        }

        return items;
    }

    onSeeAllClick = () => {
        gtm.push('See all News', 'Click', window.location.href);
    }

    render() {
        const { seeAllUrl, title } = this.props.options;
        const { showPartialPattern, isFetching } = this.state;
        const { currentPage, pageCount } = this.state.pagination;
        const items = this.getItems();
        const loadMoreCss = classNames({
            'is-loading': isFetching
        });

        if (!items.length) return null;

        return (
            <div className="news-feed-live">
                {isFetching && <BlockSpinner hasOverlay />}
                <div className="news-feed-live__header">
                    <div className="container">
                        <h2 className="news-feed-live__title title-live">{title}</h2>
                    </div>
                </div>
                <div className="news-feed-live__listing">
                    <div className="container">
                        <div className="news-feed-listing" aria-live="polite">
                            <NewsFeedListing items={items} pattern={this.state.pattern} />
                        </div>
                        {
                            (showPartialPattern || currentPage < pageCount) &&
                            <div className={`listing-load-more spinner ${loadMoreCss}`}>
                                <button
                                    type="button"
                                    className="listing-load-more__button button button--primary"
                                    onClick={this.onLoadMore}>
                                    load more
                                </button>
                            </div>
                        }
                        {
                            !showPartialPattern &&
                            currentPage === pageCount &&
                            <div className="listing-load-more">
                                <a
                                    className="listing-load-more__button button button--primary"
                                    href={seeAllUrl}
                                    onClick={this.onSeeAllClick}
                                >See all News</a>
                            </div>
                        }
                    </div>
                </div>

            </div>
        );
    }
}

NewsFeedLiveLayout.propTypes = {
    options: PropTypes.object
};

export default NewsFeedLiveLayout;
